export
const name: string = "LightingSimple";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = ``;

export
const implementation: string = `
    void setVaryingsForLighting0()
    {
    }

    void setVaryingsForLighting2(in vec3 aNormal, in vec4 aEyeSpacePosition, in vec4 aClipSpacePosition)
    {
    }
`;
